var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ticket-processor-container"},[_c('a-spin',{attrs:{"spinning":_vm.loading}},[(_vm.detail.length)?_c('div',{staticStyle:{"min-height":"260px"}},[_c('alert-info-top',{attrs:{"show-unit":false,"detail":_vm.detail,"img-height":18,"isNo":true}})],1):_c('div',{staticStyle:{"min-height":"260px","position":"relative","overflow":"hidden"}},[_c('empty-component',{attrs:{"description":"暂无数据","imgUrl":require('@/assets/images/info_empty.png'),"body-style":{
          height: '176px',
          marginTop: '28px'
        },"description-style":{
          marginTop: '-24px'
        }}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }